import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['form']

  static values = {
    delay: { default: 300, type: Number },
  }

  delayedRequest() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.timeout = setTimeout(() => this.request(), this.delayValue)
  }

  request() {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    } else {
      this.element.requestSubmit()
    }
  }
}
